<template>
    <div>
        <div
            class="tw-grid tw-grid-cols-12 tw-bg-gray-50 tw-pl-3 tw-pt-3 tw-pb-3 tw-mb-8 tw-font-semibold tw-rounded-lg tw-uppercase"
        >
            {{ $t(`teamDashboard.notificationsTitle`) }}
        </div>
        <l-skeleton-loader v-if="isLoading" />

        <div v-else-if="!notifications.length" class="tw-text-gray-400">
            {{ $t(`teamDashboard.notificationsEmpty`) }}
        </div>
        <div v-else>
            <l-notifications-list :notifications="notifications" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LSkeletonLoader from "@/components/LSkeletonLoader";
import LNotificationsList from "@/components/LUserProfile/LNotificationsList";

export default {
    components: {
        LSkeletonLoader,
        LNotificationsList,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        ...mapGetters({
            notifications: "notifications/profilePreview/notifications",
        }),
    },
    async mounted() {
        try {
            await this.$store.dispatch("notifications/profilePreview/getNotifications", {
                payload: { userId: null, type: "team" },
            });
        } finally {
            this.isLoading = false;
        }
    },
};
</script>
